import classNames from 'classnames/bind'
import ReactSelect from 'react-select'
import FormControlWrapper from '../FormControlWrapper'

const Select = props => {
  const items = [
    {
      value: '',
      label: props.placeholder || 'PLEASE SELECT',
      disabled: true,
      defaultValue: true,
      selected: true
    },
    ...props.values
  ]
  return (
    <FormControlWrapper
      id={props.id}
      name={props.name}
      label={props.label}
      required={props.required}
      horizontal={props.horizontal}
      error={props.formComponent ? (props.touched ? props.error : '') : props.error}
      help={props.help}
      size={props.size}
      disabled={props.disabled}
    >
      <div
        className={classNames({
          'mazda-select select': !props.customControl,
          'is-danger': props.formComponent && props.touched && props.error,
          [`is-${props.size}`]: props.size,
        })}
      >
        {
          props.customControl ? (
            <ReactSelect
              className={`ma-custom-select ${props.className || ''}`}
              value={props.input.value}
              name={props.input.name}
              simpleValue
              onBlur={() => props.input.onBlur(props.input.value)}
              onChange={props.input.onChange}
              onFocus={props.onFocus}
              pattern={props.pattern}
              disabled={props.disabled}
              options={items}
            />

          ) : (
            <select
              id={props.id}
              value={props.value}
              className={`select ${props.className || ''}`}
              name={props.name}
              onChange={props.handleChange}
              onBlur={props.onBlur}
              onFocus={props.onFocus}
              pattern={props.pattern}
              disabled={props.disabled}
            >
              {
                items.map(item => (
                  <option
                    className={classNames({
                      'mazda-select-option': true,
                      'is-disabled': item.disabled
                    })}
                    defaultValue={item.selected}
                    disabled={item.disabled}
                    value={item.value}
                    key={item.value}
                  >
                    {item.label}
                  </option>
                ))
              }
            </select>
          )
        }
      </div>
    </FormControlWrapper>
)}

Select.defaultProps = {
  disabled: false,
  touched: false,
  formComponent: false,
  values: [],
  size: 'small'
}

export default Select



// WEBPACK FOOTER //
// ./components/uiLib/Select/Select.jsx